import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

const HomepageTop = ({ title, img, path, date, isFirst, category }) => {
  return (
    <Link
      className={`homepageTopSection relative flex flex-col justify-end overflow-hidden focus:outline-none focus:shadow-outline ${
        isFirst
          ? "md:col-span-2 md:row-span-2 col-span-1 row-span-1"
          : "col-span-1 row-span-1"
      }`}
      to={path}
    >
      <Img
        alt={title}
        fluid={img.childImageSharp.fluid}
        className="homepageTopSection__img absolute h-full"
      />

      <div className="homepageTopSection__content absolute bottom-0 left-0 right-0 p-4 z-10">
        <div
          className={`text-indigo-800 bg-indigo-200 px-3 py-1 mb-1 inline-block rounded-full text-sm ${
            !isFirst ? "md:text-xs" : "md:text-base"
          }`}
        >
          {category}
        </div>
        {isFirst && (
          <div className="text-base my-2 text-white hidden md:block">
            <i className="fa fa-calendar-alt" />
            {`  ${date}`}
          </div>
        )}
        <h2
          className={`homepageTopSection__title leading-snug text-xl sm:text-3xl text-white hover:text-primary font-bold ${
            !isFirst ? "md:text-sm lg:text-base" : "md:text-2xl lg:text-3xl"
          }`}
        >
          {title}
        </h2>
      </div>
    </Link>
  );
};

export default HomepageTop;
